import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { ARTICLES } from "@/data/content";

const ROUTES = [
  {
    match: /^\/$/,
    title: "Arsenal Forge — We Forge Worlds",
    description: "Independent game development studio. Currently forging Territoria — 137 nations, 685 regions, one world, no resets.",
    image: "/og-banner.png",
  },
  {
    match: /^\/games\/kronix/,
    title: "KRONIX — Isometric Action MMORPG | Arsenal Forge",
    description:
      "KRONIX is a high-energy isometric action MMORPG in concept phase at Arsenal Forge — ancient arenas, temporal constructs, exaggerated combat.",
    image: "/kronix/key-art.png",
  },
  {
    match: /^\/games\/territoria/,
    title: "Territoria — Arsenal Forge",
    description: "A persistent geopolitical MMO. 137 nations. 685 regions. One world. No resets. Open beta 01.01.2027.",
    image: "/og/territoria.png",
  },
  {
    match: /^\/games/,
    title: "Our Games — Arsenal Forge",
    description: "Every world, forged in-house. Currently forging Territoria — a persistent geopolitical MMO.",
    image: "/og/games.png",
  },
  {
    match: /^\/case-studies\/arsenalwebstats/,
    title: "ArsenalWebStats Case Study — Building a Competitive Statistics Engine | Arsenal Forge",
    description:
      "Problem, build and result: how Arsenal Forge gave a five-server Rust network a memory with a production statistics bridge, wipe/season/career aggregation and one canonical player identity.",
    image: "/og/plugins.png",
  },
  {
    match: /^\/services/,
    title: "Services — Commission the Forge | Arsenal Forge",
    description:
      "Custom plugin and addon development, server operations tooling and live-ops retainers — game systems proven in production on the Arsenal Servers network.",
    image: "/og/services.png",
  },
  {
    match: /^\/downloads\/wow\/arsenal-hub/,
    title: "Arsenal Hub — WoW Forever Guild Addon | Arsenal Forge",
    description:
      "Plan guild events and raids, share captured gear, follow quests and research auction prices with Arsenal Hub for WoW Forever.",
    image: "/og/arsenalhub.png",
  },
  {
    match: /^\/projects/,
    title: "Projects — Arsenal Forge",
    description: "Rust plugins and World of Warcraft addons, forged by Arsenal Forge.",
    image: "/og/projects.png",
  },
  {
    match: /^\/plugins/,
    title: "The Foundry — Arsenal Forge",
    description: "Proprietary Oxide plugin development, forged for Rust and built for the Arsenal Servers network.",
    image: "/og/plugins.png",
  },
  {
    match: /^\/about/,
    title: "The Forge — Arsenal Forge",
    description: "Small team. Big worlds. The development arm of the Arsenal family.",
    image: "/og/about.png",
  },
  {
    match: /^\/contact/,
    title: "Contact — Arsenal Forge",
    description: "Press, careers, business or a signal from the frontier — every transmission is read.",
    image: "/og/contact.png",
  },
];

const setMeta = (selector, attrs, content) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const PageMeta = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    let route = ROUTES.find((r) => r.match.test(pathname));
    if (!route && pathname.startsWith("/journal/")) {
      const slug = pathname.split("/journal/")[1];
      const article = ARTICLES.find((a) => a.slug === slug);
      route = article
        ? {
            title: `${article.title} — Forge Journal`,
            description: article.summary,
            image: "/og/journal.png",
          }
        : {
            title: "Forge Journal — Arsenal Forge",
            description: "Studio logs, development updates and world notes. Depth over frequency.",
            image: "/og/journal.png",
          };
    } else if (!route) {
      route = {
        title: "Forge Journal — Arsenal Forge",
        description: "Studio logs, development updates and world notes. Depth over frequency.",
        image: "/og/journal.png",
      };
    }

    document.title = route.title;
    setMeta('meta[name="description"]', { name: "description" }, route.description);
    setMeta('meta[property="og:title"]', { property: "og:title" }, route.title);
    setMeta('meta[property="og:description"]', { property: "og:description" }, route.description);
    setMeta('meta[property="og:image"]', { property: "og:image" }, route.image);
    setMeta('meta[name="twitter:title"]', { name: "twitter:title" }, route.title);
    setMeta('meta[name="twitter:description"]', { name: "twitter:description" }, route.description);
    setMeta('meta[name="twitter:image"]', { name: "twitter:image" }, route.image);
  }, [pathname]);

  return null;
};

export default PageMeta;
